<template>
    <div>
        <div class="field mb-5">
            <p class="control">
                <label v-t="'creation.url_section_name'" class="label mb-0" />
                <input
                    v-model="title"
                    class="input mt-2"
                    type="text"
                    @change="emitValues"
                />
            </p>
        </div>
        <div class="field">
            <label v-t="'creation.url_link'" class="label" />
            <InputURL v-model="url" @input="emitValues" />
        </div>
    </div>
</template>

<script>
import InputURL from '@/components/InputURL';
export default {
    components: {
        InputURL,
    },
    model: {
        prop: 'info',
    },
    props: {
        info: {
            type: Object,
            default() {
                return {
                    url: null,
                    title: null,
                };
            },
        },
    },
    data() {
        return {
            url: this.info.url,
            title: this.info.title,
        };
    },
    methods: {
        emitValues() {
            this.$emit('input', {
                url: this.url,
                title: this.title,
            });
        },
    },
};
</script>

<style></style>
